import React from 'react'
import PropTypes from 'prop-types'
import { FormInputWrap } from './styled'

interface formProps {
  id: string
  error: boolean
  updater: (e) => void
  value: string | number
  type: string
  pattern?: string
  isRequired?: boolean
  onFocus: (e) => void
}

const FormInput: React.FC<{
  formProperties: formProps
}> = ({
  formProperties: {
    id,
    type,
    updater,
    value,
    isRequired = true,
    pattern,
    onFocus,
    error,
  },
}) => {
  const onHandleUpdater = (e) => {
    if (!pattern || e.target.value === '') {
      updater(e)
    } else {
      // match if in pattern logic here
      updater(e)
    }
  }

  return (
    <FormInputWrap
      data-url
      error={error}
      id={id}
      name={id}
      type={type}
      value={value}
      onChange={(e) => onHandleUpdater(e)}
      onClick={onFocus}
      required={isRequired}
      pattern={pattern}
    />
  )
}

FormInput.propTypes = {
  formProperties: PropTypes.shape({
    id: PropTypes.string.isRequired,
    updater: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    pattern: PropTypes.string,
    onFocus: PropTypes.func.isRequired,
    error: PropTypes.bool.isRequired,
    isRequired: PropTypes.bool,
  }).isRequired,
}

export default FormInput
